<template>
  <button
    class="c-link"
    :title="title"
    @click.prevent.stop="clicked()">
    <img
      v-if="icon && !iconBehind"
      class="c-link__icon icon-size"
      :src="icon" />
    <span class="c-link__text">
      <slot></slot>
    </span>
    <img
      v-if="icon && iconBehind"
      class="c-link__icon c-link__icon--behind icon-size"
      :src="icon" />
  </button>
</template>

<script>
  export default {
    props: {
      icon: {
        default: null,
        type: String,
      },
      iconBehind: {
        default: false,
        type: Boolean,
      },
      link: {
        default: null,
        type: String,
      },
      title: {
        default: null,
        type: String,
      },
    },
    methods: {
      clicked() {
        this.$emit(`click`);
      },
    },
  };
</script>

<style lang="less" scoped>
  .c-link {
    cursor: pointer;
    font-size: 13px;
    letter-spacing: 1.25px;
    text-transform: uppercase;

    &__icon {
      margin-right: 5px;
      vertical-align: middle;

      &--behind {
        margin-left: 10px;
        margin-right: 0;
      }
    }

    &__text {
      vertical-align: middle;
    }
  }
</style>
